"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var scene_1 = require("../../helpers/scene");
exports.updateScene = function (scene) {
    return {
        type: 'UPDATE_SCENE',
        scene: scene_1.cleanSceneInputs(scene),
    };
};
exports.scene = function (state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case 'UPDATE_SCENE':
            return action.scene || null;
        default:
            return state;
    }
};
